import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class EnumUtilityService {
  constructor() {}

  public getEnumKeyByValue<T>(en: T, value: string): any {
    const indexOfS = Object.values(en).indexOf(value);
    return Object.keys(en)[indexOfS];
  }
}
